<div class="position-relative">
  <input
    type="text"
    #customDateInput
    #popover="ngbPopover"
    autocomplete="off"
    class="datepicker-input"
    [disabled]="disabled"
    [class.disabled]="disabled"
    [class.calendar-open]="showingDatePicker$ | async"
    [class.form-error-border]="error"
    [attr.id]="controlId"
    [value]="displayValue$ | async"
    [container]="'body'"
    [triggers]="'manual'"
    [animation]="false"
    [autoClose]="false"
    [ngbPopover]="datePicker"
    [placement]="placement"
    [popoverClass]="'date-picker-popover'"
    [maskito]="maskitoOptions"
    [placeholder]="placeholder"
    (input)="onInput($event)"
    (blur)="onBlur()"
    (focus)="onFocus()"
    (click)="openDatePicker()"
    (keydown.tab)="closeDatePicker()"
    (keydown.shift.tab)="closeDatePicker()" />
  <button
    type="button"
    class="no-style-button datepicker-input-button"
    tabindex="-1"
    [disabled]="disabled"
    (mousedown)="$event.preventDefault()"
    (click)="openDatePicker()">
    <img [src]="inputIconSrc$ | async" alt="open datepicker" i18n-alt />
  </button>
</div>

<input
  #nativeDateInput
  class="visually-hidden"
  type="date"
  tabindex="-1"
  [disabled]="disabled"
  [min]="minDate$ | async"
  [max]="maxDate$ | async"
  [value]="nativeInputValue$ | async"
  (change)="onNativeInputChange($event)" />

<ng-template #datePicker>
  <app-datepicker-input-calendar
    [dateRange]="isUsingRange$ | async"
    [isStartDate]="isStartDate"
    [initialSelectedDates]="selectedFormattedDates$ | async"
    [minDate]="minDate$ | async"
    [maxDate]="maxDate$ | async"
    [markDisabled]="markDisabled"
    (dateSelected)="onDateSelected($event)" />
</ng-template>
